/* eslint-disable */
import { createContext, useContext, useEffect, useState } from 'react'
import LoadingModal from 'src/components/loadingModal/LoadingModal'
import { bindLoading } from 'src/helper/loadingBridge'

const LoadingContext = createContext(null)

export const LoadingProvider = ({ children }) => {
  const [loading, setLoading] = useState(false)

  useEffect(() => {
    bindLoading(setLoading)
    return () => bindLoading(null)
  }, [])

  return (
    <LoadingContext.Provider value={{ loading, setLoading }}>
      {children}
      <LoadingModal loadingModal={loading} />
    </LoadingContext.Provider>
  )
}

export const useLoading = () => {
  const context = useContext(LoadingContext)
  if (!context) {
    throw new Error('useLoading must be used within a LoadingProvider')
  }
  return context
}
